<template>
  <div class="default-chart" ref="chartdiv"></div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import _ from 'underscore'
import { mapGetters } from 'vuex'

export default {
  name: 'funnelChartRender',
  props: {
    chartKey: { type: String, required: true },
    fromDialog: { type: Boolean, required: false },
    chartOrder: { type: Array, required: false }
  },
  data () {
    return {
      chartSettings: {},
      chartData: []
    }
  },
  computed: {
    ...mapGetters(['translation']),
    chartObj: {
      get () { return this.$store.getters.getChartByKey(this.chartKey) }
    }
  },
  mounted: function () {
    this.chartSettings = this.chartObj.chartSettings
    this.chartData = this.chartObj.data.result

    // Create chart instance
    let chart = am4core.create(this.$refs.chartdiv, am4charts.SlicedChart)
    chart.hiddenState.properties.opacity = 0 // this makes initial fade in effect
    // reorder data to predefined order for sales funnel,
    // TODO move sort to server side
    let orderedData
    if (_.isArray(this.chartOrder) && this.chartOrder.length > 0) {
      orderedData = this.chartOrder
    } else {
      orderedData = ['Open', 'Pending', 'Closed', 'Converted']
    }

    let reorderedData = []
    this.chartData.forEach(function (item, index) {
      let newIndex = orderedData.indexOf(item.Status)
      if (newIndex !== -1) {
        reorderedData[newIndex] = item
      }
      // reorderedData.splice(newIndex, 0, item)
    })
    this.$log.info('new chart order', orderedData, reorderedData)
    chart.data = reorderedData

    // translate chart labels
    if (this.chartObj.data.translations) {
      chart.data.map(item => {
        // try to find translations in response from backend
        if (this.$_.has(this.chartObj.data.translations, item['Status']) && this.chartObj.data.translations[item['Status']] !== '') {
          item['Status'] = this.chartObj.data.translations[item['Status']]
        } else {
          // if backend translations not found, use front translations from biWebApp tag
          // translate only if translation found
          if (this.translation(`data.${this.chartKey}.name.${item['Status']}`) !== `data.${this.chartKey}.name.${item['Status']}`) {
            item['Status'] = this.translation(`data.${this.chartKey}.name.${item['Status']}`)
          }
        }
        return item
      })
    }

    // Enable export if 'true' in chart setting
    /* if (this.chartObj.export) {
      chart.events.on('ready', () => {
        chart.exporting.menu = new am4core.ExportMenu()
        chart.exporting.menu.align = 'right'
        chart.exporting.menu.verticalAlign = 'bottom'
        chart.exporting.menu.items = [{
          'label': '...',
          'menu': [
            {
              'label': 'Image',
              'menu': [
                { 'type': 'png', 'label': 'PNG' },
                { 'type': 'jpg', 'label': 'JPG' },
                { 'type': 'gif', 'label': 'GIF' },
                { 'type': 'svg', 'label': 'SVG' },
                { 'type': 'pdf', 'label': 'PDF' }
              ]
            }, {
              'label': 'Data',
              'menu': [
                // { 'type': 'json', 'label': 'JSON' },
                { 'type': 'csv', 'label': 'CSV' }
                // { 'type': 'xlsx', 'label': 'XLSX' }
              ]
            }, {
              'label': 'Print', 'type': 'print'
            }
          ]
        }]
      })
    } */

    let series = chart.series.push(new am4charts.FunnelSeries())
    series.dataFields.value = this.$_.keys(this.chartData[0])[1]
    series.dataFields.category = this.$_.keys(this.chartData[0])[0]
    series.alignLabels = true
    series.sliceLinks.template.height = 2
    series.sliceLinks.template.fillOpacity = 0
    series.orientation = this.chartSettings.orientation || 'horizontal'
    // series.labels.template.text = '{category}: {value.percent.formatNumber(\'#.0\')}% ([bold]{value}[/])'

    // calculate percents based on max value
    series.labels.template.adapter.add('text', slicePercent)
    series.tooltip.label.adapter.add('text', slicePercent)

    function slicePercent (text, target) {
      var max = target.dataItem.values.value.value + Math.abs(target.dataItem.values.value.change)
      var percent = 0
      target.dataItem.values.value.change !== 0
        ? percent = (target.dataItem.values.value.value / max * 100).toFixed(2)
        : percent = (target.dataItem.values.value.value / max * 100)
      if (isNaN(percent)) percent = 0
      return '{category}: ' + percent + '% ([bold]{value}[/])'
    }

    if (this.chartSettings.legend) {
      chart.legend = new am4charts.Legend()
      chart.legend.position = this.chartSettings.legendPosition || 'bottom'
      chart.legend.margin(5, 5, 30, 5)
    }

    // Enable export if 'true' in chart setting
    if (chart && this.chartObj.export) {
      chart.exporting.menu = new am4core.ExportMenu()
      chart.exporting.menu.align = 'right'
      chart.exporting.menu.verticalAlign = 'bottom'
    }

    this.chart = chart
  },
  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.default-chart {
  width: 100%;
  height: 100%;
}
</style>
